import axios from "axios";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { WEB_API } from "../../../config/variables";
import BaseLayout from "../../Layouts/BaseLayout";
import PageBanner from "../../Layouts/PageBanner";

export class VoteDetail extends Component {
  state = {
    voteDetail: {},
    blockId: "",
    date: "",
  };

  async componentDidMount() {
    try {
      const { txId } = this.props.match.params;

      const res = await axios.get(`/api/get/vote/${txId}`);

      const { voteDetail, date, blockId } = res.data;

      this.setState({ voteDetail, date, blockId });
    } catch (error) {
      console.log("xxx Get vote detail : ", error);
    }
  }

  render() {
    const { voteDetail, blockId, date } = this.state;

    const title =
      this.props.lang === "en"
        ? "Vote detail - Poinsettia Festival English 2019"
        : "Thông tin phiểu bình chọn - MC nhí Hồ Chí Minh 2023";

    return (
      <BaseLayout
        title={title}
        description={title}
        setLang={this.props.setLang}
      >
        <main id="main">
          <PageBanner />

          <section className="section-block">
            <div className="bs-container">
              <div className="bs-row">
                <div className="bs-col">
                  <div className="module module-block">
                    <div className="module-content">
                      <div className="vote-content block-content">
                        <div className="content-code">
                          <div className="bs-row row-md-15">
                            <div className="bs-col lg-50-15 md-55-15">
                              <div className="item">
                                <p className="desc">
                                  <FormattedMessage id="voteId" />
                                </p>
                                <p className="title">{voteDetail._id}</p>
                              </div>
                            </div>
                            <div className="bs-col lg-50-15 md-45-15">
                              <div className="item">
                                <p className="desc">
                                  <FormattedMessage id="block" />
                                </p>
                                <div className="title">{blockId}</div>
                                {/* <Link
                                  to={`/khoi/${parseInt(blockId)}/${
                                    parseInt(blockId) + 2
                                  }`}
                                  className="title blue"
                                >
                                  {blockId}
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="table-content">
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  <FormattedMessage id="voterId" />
                                </th>
                                <th>
                                  <FormattedMessage id="voted" />
                                </th>
                                <th>
                                  <FormattedMessage id="time" />
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <Link
                                    to={`/nguoi-binh-chon/${voteDetail.voterId}`}
                                  >
                                    {voteDetail.voterId}
                                  </Link>
                                </td>
                                <td> {voteDetail.contestantName}</td>
                                <td>{date} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </BaseLayout>
    );
  }
}

export default VoteDetail;
